module.exports = __webpack_public_path__ + "img/android_code.b0e8c5f0.png";